var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 mb-2"},[_c('page-nav',{attrs:{"icn":"fas fa-paper-plane text-primary","lab":"応募履歴（案件）"},on:{"do_click":_vm.toApplyPjHis}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }